export const MOCK_SERVER_BASE_URLS = {
  api: "http://localhost:3001/sat-common-svc/api/v1",
  session: "http://localhost:3001/sat-motor-svc/v1",
  common: "http://localhost:3001/alpha-modular-svc/v1/common",
} as const;
